/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function(React, UIToolkit, PropTypes) {
	var CenterLoadingSpinner = function(props) {
		return (
			<div className='loadingBlocker blockerCenterContents'>
				<UIToolkit.ProgressIndicator size={props.size} variant= {props.variant} />
			</div>
		);
	};

	CenterLoadingSpinner.propTypes = {
		size: PropTypes.string.isRequiried,
		variant: PropTypes.string.isRequiried
	};

	return CenterLoadingSpinner;
});
